export const environment = {
  auditLogApiUrl:
    process.env.AUDIT_LOG_API ||
    // "https://api-dev.tingg.africa/audittrails/v1/audits-api", // apigee
    "https://audit-trail.dev.tingg.africa/audittrails/v1/audits-api", // direct to cas
  timeApiUrl:
    process.env.TIME_API || "https://api-approval.tingg.africa/api/time",
  importMapDeployerUrl: "https://import-map-deployer.dev.tingg.africa/",
};

export type ITinggProductCodeName =
  | "Dashboard"
  | "Onboarding"
  | "Finance"
  | "Messaging"
  | "Payments"
  | "Payouts"
  | "Reports"
  | "Customers"
  | "Developer"
  | "Admin"
  | "Online"
  | "InStore"
  | "Pay By Link"
  | "Payment Page"
  | "Charge"
  | "Card Admin"
  | "Subscription"
  | "CAS"
  | "Signup"
  | "Side Navigation App"
  | "Top Navigation App"
  | "Instore V2"
  | "Pay By Link V2"
  | "Ussd Gateway"
  | "Dynamic Routing"
  | "Virtual Accounts"
  | "Billing Factors"
  | "Supplier Financing";

/* *** Apps that are DEPENDENT on side-nav ***
 *  These must be registered after side-nav
 */
interface IProduct {
  appName: string;
  activeWhen: string;
  codeName: ITinggProductCodeName;
}

export const productApplications: IProduct[] = [
  {
    appName: "@tingg/onboarding",
    activeWhen: "/onboarding",
    codeName: "Dashboard",
  },
  {
    appName: "@tingg/admin-onboarding-ui",
    activeWhen: "/customer",
    codeName: "Onboarding",
  },
  {
    appName: "@tingg/settlement-ui",
    activeWhen: "/finance",
    codeName: "Finance",
  },
  {
    appName: "@tingg/messages",
    activeWhen: "/messaging",
    codeName: "Messaging",
  },
  {
    appName: "@tingg/payments",
    activeWhen: "/payments",
    codeName: "Payments",
  },
  {
    appName: "@tingg/payouts",
    activeWhen: "/payouts",
    codeName: "Payouts",
  },
  {
    appName: "@tingg/reports",
    activeWhen: "/reports",
    codeName: "Reports",
  },
  {
    appName: "@tingg/customers",
    activeWhen: "/customers",
    codeName: "Customers",
  },
  {
    appName: "@tingg/developer",
    activeWhen: "/developer",
    codeName: "Developer",
  },
  {
    appName: "@tingg/admin",
    activeWhen: "/admin",
    codeName: "Admin",
  },
  {
    appName: "@tingg/online",
    activeWhen: "/online",
    codeName: "Online",
  },
  {
    appName: "@tingg/instore",
    activeWhen: "/instore",
    codeName: "InStore",
  },
  {
    appName: "@tingg/pay",
    activeWhen: "/pay-by-link",
    codeName: "Pay By Link",
  },
  {
    appName: "@tingg/page",
    activeWhen: "/payment-page",
    codeName: "Payment Page",
  },
  {
    appName: "@tingg/charge",
    activeWhen: "/charge",
    codeName: "Charge",
  },
  {
    appName: "@tingg/card-admin",
    activeWhen: "/card-admin",
    codeName: "Card Admin",
  },
  {
    appName: "@tingg/subscription",
    activeWhen: "/subscription",
    codeName: "Subscription",
  },
  {
    appName: "@tingg/v2-instore",
    activeWhen: "/v2-instore",
    codeName: "Instore V2",
  },
  {
    appName: "@tingg/v2-pay",
    activeWhen: "/payment-links",
    codeName: "Pay By Link V2",
  },
  {
    appName: "@tingg/ussd-gateway",
    activeWhen: "/ussd-gateway",
    codeName: "Ussd Gateway",
  },
  {
    appName: "@tingg/dynamic-routing-ui",
    activeWhen: "/dynamic-routing",
    codeName: "Dynamic Routing",
  },
  {
    appName: "@tingg/virtual-accounts",
    activeWhen: "/virtual-accounts",
    codeName: "Virtual Accounts",
  },
  {
    appName: "@tingg/billing-factors",
    activeWhen: "/billing-factor",
    codeName: "Billing Factors",
  },
  {
    appName: "@tingg/supplier-financing",
    activeWhen: "/supplier-financing",
    codeName: "Supplier Financing",
  }
];

export const allTinggApplications: IProduct[] = [
  ...productApplications,
  {
    appName: "@tingg/cas-ui-app",
    activeWhen: "/cas",
    codeName: "CAS",
  },
  {
    appName: "@tingg/signup",
    activeWhen: "/signup",
    codeName: "Signup",
  },
  {
    appName: "@tingg/top-nav",
    activeWhen: "/",
    codeName: "Top Navigation App",
  },
  {
    appName: "@tingg/side-navigation-ui-app",
    activeWhen: "/",
    codeName: "Side Navigation App",
  },
];

export const tinggAppsBaseRoutes = [
  "cas",
  "signup",
  "onboarding",
  "customer",
  "payments",
  "payouts",
  "messaging",
  "instore",
  "admin",
  "finance",
  "reports",
  "customers",
  "developer",
  "online",
  "pay-by-link",
  "payment-page",
  "charge",
  "card-admin",
  "subscription",
  "v2-instore",
  "payment-links",
  "ussd-gateway",
  "dynamic-routing",
  "virtual-accounts",
  "billing-factor",
  "supplier-financing"
];

export const routesStartsWithToShowSideNav = [
  "/payments",
  "/payouts",
  "/admin",
  "/instore",
  "/finance",
  "/developer",
  "/messaging",
  "/customers",
  "/reports",
  "/online",
  "/pay-by-link",
  "/payment-page",
  "/cas/change-password",
  "/onboarding",
  "/customer/setup",
  "/customer/admin/setup",
  "/customer/live",
  "/customer/leads",
  "/customer/onboarding",
  "/charge",
  "/card-admin",
  "/subscription",
  "/v2-instore",
  "/payment-links",
  "/ussd-gateway",
  "/dynamic-routing",
  "/virtual-accounts",
  "/billing-factor",
  "/supplier-financing"
];

export const productOnboardingApps = [
  {
    appName: "@tingg/online",
    productCode: "checkout",
    routes: [
      "/online/test-onboarding",
      "/online/test-onboarding/express-checkout",
      "/online/test-onboarding/understand-checkout",
    ],
  },
  {
    appName: "@tingg/instore",
    productCode: "instore",
    routes: [
      "/instore/create-onbording-store",
      "/instore/trial-counter",
      "/instore/setup-store",
    ],
  },
  {
    appName: "@tingg/pay",
    productCode: "payment-links",
    routes: ["/pay-by-link/onboarding"],
  },
  {
    appName: "@tingg/page",
    productCode: "payment-pages",
    routes: ["/payment-page/onboarding"],
  },
];
